import JassEventId from './eventid';

/**
 * type playerunitevent
 */
export default class JassPlayerUnitEvent extends JassEventId {}
